import { Box, forwardRef, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import parseHtml from '../../helpers/parseHtml'
import HtmlWrapper from '../Blocks/Collection/HtmlWrapper'
import RatioImage from '../RatioImage'

const ProjectHeading = forwardRef(({
  image,
  name,
  description,
  isPreview,
  isEditing,
  editorRef,
  prices,
  ...props
}, ref) => {
  return (
    <Stack
      py={2}
      ref={ref}
      {...props}
    >
      <RatioImage width="100%" ratio={2} src={image} isPreview={isPreview} isEditing={isEditing} rounded="lg" overflow="hidden" />
      <HtmlWrapper px="2">
        {description && parseHtml(description)}
      </HtmlWrapper>

    </Stack>
  )
})

export default ProjectHeading
